import { render, staticRenderFns } from "./EspecificacaoProdutoForm.vue?vue&type=template&id=d9ccf926"
import script from "./EspecificacaoProdutoForm.vue?vue&type=script&lang=js"
export * from "./EspecificacaoProdutoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports